import Switch from '@mui/material/Switch';
import { Tooltip } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

interface ToggleMagasinProps {
    title: string,
    manquant: boolean,
    setManquant: (manquant: boolean) => void
}

export default function ToggleMagasin({ title, manquant, setManquant }: ToggleMagasinProps) {
    const theme = createTheme({
        components: {
            MuiSwitch: {
                styleOverrides: {
                    switchBase: {
                        // Controls default (unchecked) color for the thumb
                        color: "grey"
                    },
                    colorPrimary: {
                        "&.Mui-checked": {
                            // Controls checked color for the thumb
                            color: "#007bff"
                        }
                    },
                    track: {
                        // Controls default (unchecked) color for the track
                        backgroundColor: "#ffffff",
                        ".Mui-checked.Mui-checked + &": {
                            // Controls checked color for the track
                            opacity: 0.7,
                            backgroundColor: "#007bff"
                        }
                    }
                }
            }
        }
    });

    return <>
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <span>{title}</span>
            <ThemeProvider theme={theme}>
                <Tooltip title={"Manquant"}>
                    <Switch size='small' onChange={(e) => { setManquant(e.target.checked); }} checked={manquant} />
                </Tooltip>
            </ThemeProvider>
        </div>
    </>
}